export default __webpack_public_path__ + "static/media/logo.a193fc4c.png";